import {UnstableCard as Paper} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import {type ReactElement} from 'react'

import {AddressProvider} from '../../contexts/AddressContext'
import {renderWidget} from '..'
import type {FormWidgetConfig} from '../types'
import * as classes from './Form.classes'

export const FormWidget = ({header_section, sections, bottom_section}: FormWidgetConfig): ReactElement => {
  return (
    <AddressProvider>
      {header_section && (
        <Paper className={classes.headerSection} padding="none" radius="L" noOverflow>
          {header_section.widgets.map(renderWidget)}
        </Paper>
      )}
      {sections.map((section, index) => (
        <Paper
          key={index}
          className={clsx(classes.bodySection, {[classes.bodySectionSquareTop]: index === 0})}
          radius="L"
          noOverflow
        >
          {section.widgets.map(renderWidget)}
        </Paper>
      ))}
      {bottom_section && <div className={classes.bottomSectionWrapper}>{bottom_section.widgets.map(renderWidget)}</div>}
    </AddressProvider>
  )
}
